import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class GetRecurringTripCommand extends IRequestCommand<
  IGetRecurringTripResponse,
  ErrorDetails,
  IGetRecurringTripCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/recurringTrip/paginated';

  public override setParameters(parameters: IGetRecurringTripCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    const params: string[] = [];
    params.push(`page=${parameters.page}`);
    params.push(`size=${parameters.size}`);
    params.push(`column=${parameters.column}`);
    params.push(`sort=${parameters.sort}`);
    params.push(`status=${parameters.status}`);
    if (parameters.find !== undefined && parameters.find !== null) {
      params.push(`find=${encodeURIComponent(parameters.find)}`);
    }
    this._commandUrl += '?' + params.join('&');
  }
}

export interface IGetRecurringTripCommandParameters extends ICommandParameters {
  carrierId: number;
  page: number;
  size: number;
  column: string;
  sort: string;
  status: string;
  find?: string;
}

export interface IGetRecurringTripResponse extends ICommandResponse {
  content: IRecurringTripResponseDTO[];
  totalElements: number;
  totalPages: number;
}

export interface IRecurringTripResponseDTO {
  id: number;
  carrierId: number;
  passengerName: string;
  periodicityType: string;
  periodicity: number;
  startDate: string;
  endDate: string;
  nextExecution?: string;
  lastExecution: string;
  origin: string;
  destination: string;
  note?: string;
  selectedDaysOfWeek: string[];
  originLat?: string;
  originLng?: string;
  pickupGmt: string;
  errorCode?: string;
  areaId?: number;
  paxQty?: number;
  isCorporative?: boolean;
  paxAreaId?: number;
  paxAreaName?: string;
  authAreas?: any;
  reasonToCancel?: string;
  cancelDate?: string;
  cancelUserId?: number;
  cancelUserName?: string;
}
